import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import {
  get,
  size,
  filter,
  cloneDeep,
  debounce,
  map,
  includes,
  // isEmpty,
} from "lodash";
import { v4 as uuidv4 } from "uuid";
import * as crypto from 'crypto-js';
import { API_LUKE } from "../../../constants/api";
import { OCR, LPR } from "../../../constants/common";
import {
  fetchGet,
  fetchPost,
  fetchPut,
  //fetchDelete
} from "../../../api/fetch";
import {
  getAttributeValue,
  getAttributeValues,
  cloneCleanAttributes,
  checkOverrideRecords,
  processTotalRecords,
  getProfileTypeIcon,
} from "../../../utils/profile";
import { validatePhone, validateSingleField } from "../../../utils/form";
import { getLov } from "../../../utils/lov";
import { isAllowed } from "../../../utils/users";
import { getAttributeName } from "../../../utils/attributes";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Checkbox from "@material-ui/core/Checkbox";

import Loader from "../../Common/Loader";
import Picture from "../../Common/Picture";
import CustomButton from "../../Common/CustomButton";
import DetailsContainer from "../../Common/DetailsContainer";
import FormSection from "../../Common/FormSection";

import HumanForm from "./HumanForm";
import HumanFormExpress from "./HumanFormExpress";
import VehicleForm from "./VehicleForm";
import GenericForm from "./GenericForm";
import ContainerService from "../../../utils/containerISO6346";
import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import InfoSection from "../../Common/InfoSection";
import { excludeAttr } from "../../../constants/profiles";
import ProfileLocation from "../ProfileView/ProfileLocation";
import { fetchDataStoreKey } from "../../../utils/datastore";
import ContainerForm from './ContainerForm';
import RailCarForm from "./RailCarForm";

const styles = {
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    width: "400px",
    maxHeight: "calc(100vh - 100px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px 24px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1em",
    margin: "20px",
    color: colors.black54,
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
  },
  sectionCol: {
    padding: "10px 24px 0px 24px",
    minWidth: "248px",
    maxWidth: "308px",
  },
  greyBackground: {
    backgroundColor: colors.tableDarkBg,
    paddingTop: "20px",
    marginTop: "20px",
    paddingBottom: "0px",
  },
};

const ProfileForm = (props) => {
  const {
    classes,
    user,
    profile,
    profileType,
    language,
    setCreatedProfile,
    disablePhotos = false,
    detectionId = null,
    flow = null,
    permission = false,
    //profileTypeDetails,
  } = props;
  const isMounted = React.useRef(true);
  const [formValues, setFormValues] = React.useState({});
  const [lov, setLov] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [validForm, setValidForm] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [photos, setPhotos] = React.useState([]);
  const [localPhotos, setLocalPhotos] = React.useState([]);
  const [profileAttributes, setProfileAttributes] = React.useState();
  const [warningProcess, setWarningProcess] = React.useState(false);
  const [deleteProcess, setDeleteProcess] = React.useState(false);
  const [bulkOverrideEnabled, setBulkOverrideEnabled] = React.useState(true);
  const [existingRecords, setExistingRecords] = React.useState({
    [LPR]: { count: 0, records: [] },
    [OCR]: { count: 0, records: [] },
    total: { count: 0, records: [] },
  });
  const [profileValidationRules, setProfileValidationRules] = React.useState({});
  
  React.useEffect(() => () => (isMounted.current = false), []);

  React.useEffect(() => {
      let attributes = profileAttributes;
      const activeAttributes = filter(
        attributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      );
      
      if(activeAttributes && activeAttributes.length) {
        const requiredAttributes = filter(
          activeAttributes,
          (attr) => attr.required
        );
        
        if(requiredAttributes && requiredAttributes.length) {
          let finalAttributes={'tag': false};
          requiredAttributes.forEach((item) => {
            finalAttributes = {
              ...finalAttributes,
              [item.id]: false
            }
          })
        
          setValidForm(finalAttributes)
        }
      // }
    }
  }, [profileAttributes, profileType, excludeAttr]);

  React.useEffect(() => {
    fetchProfileAttributes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileType]);

  const fetchProfileAttributes = async () => {
    try {
      let attributes = await fetchGet(
        `profile_types/${profileType}/attributes`
      );
      setProfileAttributes(attributes);

      let lovAttributes = map(
        filter(attributes, (attr) =>
          includes(["radiobutton", "lov(picker)"], get(attr, ["data_type"]))
        ),
        (attr) => attr.id
      );
      let lovAttr = {};
      for (let i = 0; i < size(lovAttributes); i++) {
        let attr = get(lovAttributes, [i]);
        lovAttr[attr] = await getLov(attr);
      }
      setLov({
        ...lovAttr,
        tag: await getLov("tags"),
        profileTypes: await getLov("profileTypes"),
        companies: get(user, ["companies"]),
        // companies: await fetchGet("companies"),
        // sites: get(profile, ["company_id"])
        //   ? await fetchGet(`companies/${get(profile, ["company_id"])}/sites`)
        //   : [],
        // zones: get(profile, ["site_id"])
        //   ? await fetchGet(
        //       `companies/${get(profile, ["company_id"])}/sites/${get(profile, [
        //         "site_id",
        //       ])}/zones`
        //     )
        //   : [],
      });
      //initiateValues(attributes);
    } catch (e) {
      console.log(e);
    }
  };

  const initiateValues = (pAttr) => {
    if (profile) {
      let newFormValues = {
        profile_type_id: profile.profile_type_id,
        active: profile.active !== undefined ? profile.active : true,
        attributes: cloneCleanAttributes(
          profileType,
          profile.attributes,
          pAttr || profileAttributes
        ),
        company_id:
          get(profile, ["company_id"]) ||
          (isAllowed(get(user, ["permissions"]), "access.cross.companies.admin")
            ? null
            : get(user, ["assignedCompany"])),
        site_id:
          get(profile, ["site_id"]) ||
          (isAllowed(get(user, ["permissions"]), "access.cross.sites.admin")
            ? null
            : get(user, ["assignedSite"])),
        zone_id: get(profile, ["zone_id"]),
        current_loc_site_id: get(profile, ["current_loc_site_id"]),
        current_loc_zone_id: get(profile, ["current_loc_zone_id"]),
      };
      if (get(profile, ["tag", "id"])) {
        newFormValues.sys_tag_id = get(profile, ["tag", "id"]);
      }
      setFormValues(newFormValues);
      validation(newFormValues, null, pAttr || profileAttributes);
    } else {
      setFormValues({
        profile_type_id: profileType,
        active: true,
        attributes: [],
        company_id: isAllowed(
          get(user, ["permissions"]),
          "access.cross.companies.admin"
        )
          ? null
          : get(user, ["assignedCompany"]),
        site_id: isAllowed(
          get(user, ["permissions"]),
          "access.cross.sites.admin"
        )
          ? null
          : get(user, ["assignedSite"]),
      });
    }
    if (props.photos) {
      setPhotos(props.photos);
    }
    if (props.newProfilePhotos) {
      setLocalPhotos(props.newProfilePhotos);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    // if (size(profileAttributes) > 0 && !isEmpty(profileValidationRules)) {
    //   initiateValues();
    // }
    initiateValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(profile), profileValidationRules]);

  React.useEffect(() => {
    const fetchProfileRules = async () => {
      try {
        let [phoneValidation, phoneRequired, emailValidation, emailRequired,containerIdValidation,satcValidation] =
          await Promise.all([
            fetchDataStoreKey("profile.phone.validation"),
            fetchDataStoreKey("profile.phone.required"),
            fetchDataStoreKey("profile.email.validation"),
            fetchDataStoreKey("profile.email.required"),
            fetchDataStoreKey("profile.container-id.validation"),
            fetchDataStoreKey("profile.container-satc.validation")
          ]);
        if (
          !includes(
            ["no-duplicates", "duplicate-warn", "duplicate-silent"],
            phoneValidation
          )
        )
          phoneValidation = "duplicate-warn";
        if (
          !includes(
            ["no-duplicates", "duplicate-warn", "duplicate-silent"],
            emailValidation
          )
        )
          emailValidation = "duplicate-warn";
        setProfileValidationRules({
          phoneValidation: phoneValidation,
          phoneRequired: phoneRequired || false,
          emailValidation: emailValidation,
          emailRequired: emailRequired || false,
          containerIdValidation,
          satcValidation
        });
        if (phoneRequired || emailRequired) {
          if (permission) {
            setValidForm(
              update(validForm, {
                195: { $set: !emailRequired },
                34: { $set: [!phoneRequired] },
                form: true,
              })
            );
          } else {
            setValidForm(
              update(validForm, {
                34: { $set: [!phoneRequired] },
                form: true,
              })
            );
          }
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    };
    fetchProfileRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkBulkOverride = async (newFormValues, type, newExistingRecords) => {
    try {
      let newRecords = await checkOverrideRecords(
        type,
        newFormValues,
        profileType,
        detectionId
      );
      setExistingRecords(
        processTotalRecords(
          update(newExistingRecords, {
            [type]: { $set: newRecords },
          })
        )
      );
    } catch (e) {
      console.log(e);
    }
  };

  function checkValid(valid) {
    for (var key in valid) {
      const driverLicence = valid[39] ? valid[207] : false;
    
      if (key !== "form" && driverLicence === false && valid[key] === false) return false;
    }
    return true;
  }

  const debouncedValidation = React.useCallback(
    debounce(
      async (
        newFormValues,
        valid,
        newErrors,
        field,
        newExistingRecords,
        profileAttributes,
        profileValidationRules
      ) => {
        if (!field) {
          await validateAllFields(
            newFormValues,
            newExistingRecords,
            profileAttributes,
            profileValidationRules
          );
        } else {
          [valid, newErrors] = await validateOneField(
            newFormValues,
            valid,
            newErrors,
            field,
            newExistingRecords,
            profileAttributes,
            profileValidationRules
          );
          valid["form"] = checkValid(valid);
          setValidForm(valid);
          setErrors(newErrors);
          return valid;
        }
      },
      500
    ),
    []
  );

  const validation = (newFormValues, field, profileAttributes) => {
    debouncedValidation(
      newFormValues,
      { ...validForm },
      { ...errors },
      field,
      existingRecords,
      profileAttributes,
      profileValidationRules
    );
  };

  const updateUnitWithRailCarType=(id,value,newFormValues)=>{
    if (id == 283) {
      if (value == 181) {
        newFormValues.attributes.push({
          id: 300,
          value: 205,
        });
      } else {
        newFormValues.attributes = newFormValues.attributes.filter(
          (value) => value.id != 300
        );
      }
    }
  }
  const handleChange = (id, index, value, subAttributeId) => {
    if (!isNaN(parseInt(id))) {
      let newFormValues = cloneDeep(formValues);
      let attributes = newFormValues.attributes.filter(
        (attr) => attr.id === id
      );
      if (id === 34 && !isNaN(parseInt(value))) value = parseInt(value);
      if (attributes.length <= index) {
        if (subAttributeId) {
          newFormValues.attributes.push({
            id,
            value: "",
            attributes: [
              {
                id: subAttributeId,
                value,
              },
            ],
          });
        } else {
          newFormValues.attributes.push({
            id,
            value,
          });
          updateUnitWithRailCarType(id,value,newFormValues)
        }
      } else {
        if (subAttributeId) {
          if (isNaN(parseInt(subAttributeId))) {
            attributes[index][subAttributeId] = value;
          } else if (attributes[index].attributes) {
            if (
              attributes[index].attributes.filter(
                (attr) => attr.id === subAttributeId
              ).length > 0
            ) {
              attributes[index].attributes.filter(
                (attr) => attr.id === subAttributeId
              )[0].value = value;
            } else {
              attributes[index].attributes.push({
                id: subAttributeId,
                value: value,
              });
            }
          } else {
            attributes[index].attributes = [
              { id: subAttributeId, value: value },
            ];
          }
        } else {
          if (value === null || value === "") {
            attributes = update(attributes, {
              $splice: [[index, 1]],
            });
            newFormValues.attributes = [
              ...newFormValues.attributes.filter((attr) => attr.id !== id),
              ...attributes,
            ];
          } else {
            attributes[index].value = value;
          }
          updateUnitWithRailCarType(id,value,newFormValues)
        }
      }
      setFormValues(newFormValues);
      validation(newFormValues, id, profileAttributes);
      if(id==301){
        validation(newFormValues, 291, profileAttributes)
      }
    } else if (
      [
        "sys_tag_id",
        "active",
        "company_id",
        "site_id",
        "zone_id",
        "current_loc_site_id",
        "current_loc_zone_id",
      ].includes(id)
    ) {
      let newFormValues = update(formValues, {
        [id]: { $set: value },
      });
      if (id === "company_id" && value !== formValues.company_id) {
        newFormValues = update(newFormValues, {
          site_id: { $set: null },
          zone_id: { $set: null },
        });
      } else if (id === "site_id" && value !== formValues.site_id) {
        newFormValues = update(newFormValues, {
          zone_id: { $set: null },
        });
      } else if (
        id === "current_loc_site_id" &&
        value !== formValues.current_loc_site_id
      ) {
        newFormValues = update(newFormValues, {
          current_loc_zone_id: { $set: null },
        });
      }
      setFormValues(newFormValues);
      validation(newFormValues, id, profileAttributes);
    }
  };

  const validateAllFields = async (
    newFormValues,
    newExistingRecords,
    profileAttributes,
    profileValidationRules
  ) => {
    let valid = {};
    let newErrors = {};
    let fields;
    if (profileType === 1) {
      fields = [31, 32, 195, 34, 35, 207, "sys_tag_id"];
    } else if ([2, 3].includes(profileType)) {
      fields = [
        18,
        profileType === 2 ? 42 : profileType === 3 ? 53 : 54,
        89,
        44,
        50,
        "sys_tag_id",
      ];
    } else {
      fields = map(
        filter(profileAttributes, (attr) => attr.active && attr.required),
        (attr) => attr.id
      );
    }
    for (let i = 0; i < size(fields); i++) {
      if (!permission && fields[i] !== 195) {
        [valid, newErrors] = await validateOneField(
          newFormValues,
          valid,
          newErrors,
          fields[i],
          newExistingRecords,
          profileAttributes,
          profileValidationRules
        );
      }
    }
    setValidForm(valid);
    setErrors(newErrors);
  };

  const isValidContainerID = (containerID,containerIdValidation,ISOCompilationValue) => {

    const ISO_CODE_10_DIGITS = /^[a-zA-Z]{3}[uUjJzZ]{1}(\s*)?[0-9]{6}$/;
    if (ISOCompilationValue) {
      if (
        (containerID?.length<11 && containerID.match(ISO_CODE_10_DIGITS)) || 
        (containerID?.length==11 && ContainerService.validateCheckDigit(containerID))
      )
        return true;
    } else if (
      !containerIdValidation.regex ||
      containerID.match(containerIdValidation.regex)
    )
      return true;
    return false
  };
  const getOcrTypeValue = (containerID, ocrTypeId) => {
    switch (ocrTypeId) {
      case 201: return containerID.slice(0,3);
      case 202: return containerID.slice(3,4);
      case 203: return containerID.slice(4,10)
      default: return containerID
    }
  };
  const ocrValueUpdate = (containerID, newFormValues, isRemove = false) => {
    let ocr = getAttributeValues(newFormValues, 50);
    const ocrTypeIds = [201, 202, 203, 204];
    if (isRemove) {
      ocr = ocr.filter(
        (ocrValue) => !ocrTypeIds.includes(ocrValue?.attributes[0]?.value)
      );
    } else {
      ocrTypeIds.map((ocrTypeId) => {
        let ocrTypeValue = getOcrTypeValue(containerID, ocrTypeId);
        let flag = true;
        for (let ocrValue of ocr) {
          if (ocrValue?.attributes[0]?.value === ocrTypeId) {
            ocrValue.value = ocrTypeValue;
            ocrValue.displayValue = ocrTypeValue;
            ocrValue.mandatory_match = ocrTypeId==204;
            flag = false;
            break;
          }
        }
        if (flag) {
          let currentOcr = {
            value: ocrTypeValue,
            displayValue: ocrTypeValue,
            mandatory_match: ocrTypeId==204,
            id: 50,
            attributes: [
              {
                id: 135,
                value: ocrTypeId,
              },
            ],
          };
          ocr.push(currentOcr);
        }
      });
    }

    newFormValues.attributes = [
      ...newFormValues.attributes.filter((attr) => attr.id !== 50),
      ...ocr,
    ];

    setFormValues(newFormValues);
  };

  const validateOneField = async (
    newFormValues,
    validation,
    err,
    lastModified,
    newExistingRecords,
    profileAttributes,
    profileValidationRules
  ) => {
    let valid = { ...validation };
    let newErrors = { ...err };
    if (profileType === 1) {
      if ([31, 32, 35].includes(lastModified)) {
        valid[lastModified] = getAttributeValue(newFormValues, lastModified)
          ? true
          : false;
      } else if (lastModified === "sys_tag_id") {
        valid.tag = newFormValues.sys_tag_id ? true : false;
      } else if ([195, 34, 37, 38].includes(lastModified)) {
        if (lastModified === 195) {
          [valid[lastModified], newErrors[lastModified]] =
            await validateSingleField(
              lastModified,
              getAttributeValue(newFormValues, lastModified),
              get(profileValidationRules, ["emailRequired"]),
              get(profileValidationRules, ["emailValidation"]),
              get(profile, ["id"])
            );
        } else if (includes([37, 38], lastModified)) {
          [valid[lastModified], newErrors[lastModified]] =
            await validateSingleField(
              lastModified,
              getAttributeValue(newFormValues, lastModified),
              false,
              "",
              get(profile, ["id"])
            );
        } else if (lastModified === 34) {
          let newErrors34 = { ...newErrors[34] };
          let attributes34 = getAttributeValues(newFormValues, 34);
          valid[34] = [];
          if (
            size(attributes34) === 0 &&
            get(profileValidationRules, ["phoneRequired"])
          ) {
            valid[34] = [false];
          } else {
            for (let index = 0; index < size(attributes34); index++) {
              let phone = attributes34[index];
              if (
                (!phone.value &&
                  get(profileValidationRules, ["phoneRequired"])) ||
                !getAttributeValue(phone, 194)
              ) {
                valid[34][index] = false;
              } else if (!validatePhone(phone.value)) {
                valid[34][index] = false;
                newErrors34 = update(newErrors34, {
                  [index]: { $set: I18n.get("profiles_formatInvalid") },
                });
              } else if (
                includes(
                  ["no-duplicates", "duplicate-warn"],
                  get(profileValidationRules, ["phoneValidation"])
                )
              ) {
                try {
                  let valueExists = await fetchPost("profiles/search/phone", {
                    phone: phone.value.toString(),
                    profile_type: 1,
                  });
                  if (
                    get(valueExists, ["count"]) === 0 ||
                    size(
                      filter(
                        get(valueExists, ["profiles"]),
                        (p) => p.id !== get(profile, ["id"])
                      )
                    ) === 0
                  ) {
                    valid[34][index] = true;
                    newErrors34 = update(newErrors34, {
                      [index]: { $set: null },
                    });
                  } else {
                    valid[34][index] =
                      get(profileValidationRules, ["phoneValidation"]) ===
                      "no-duplicates"
                        ? false
                        : true;
                    newErrors34 = update(newErrors34, {
                      [index]: { $set: I18n.get("profiles_phoneAlreadyInUse") },
                    });
                  }
                } catch (e) {
                  console.log(e);
                  valid[34][index] = false;
                }
              }
            }
          }
          newErrors[34] = newErrors34;
        }
      }
      valid.form = valid[31] && valid[32] && valid[35] && valid["tag"] ? true : false;
      
    } else if ([2, 3].includes(profileType)) {
      if (lastModified === "sys_tag_id") {
        valid.tag = newFormValues.sys_tag_id ? true : false;
      } else if ([18, profileType === 2 ? 42 : 53, 89].includes(lastModified)) {
        valid[lastModified] = getAttributeValue(newFormValues, lastModified)
          ? true
          : false;
      } else if (lastModified === 44) {
        let lpr = getAttributeValue(newFormValues, 44);
        if (!lpr || lpr.length < 2) {
          valid[44] = false;
        } else {
          try {
            let lprExists = await fetchPost("profiles/search/lpr", {
              lpr,
              profile_type: profileType,
            });
            if (
              lprExists.count === 0 ||
              (profile &&
                profile.id &&
                lprExists.profiles.filter((p) => p.id !== profile.id).length ===
                  0)
            ) {
              valid[44] = true;
              newErrors[44] = null;
            } else {
              valid[44] = false;
              newErrors[44] = I18n.get("profiles_lprAlreadyExists");
            }

            // Check bulk override if not update
            if (!profile || !profile.id) {
              checkBulkOverride(newFormValues, LPR, newExistingRecords);
            }
          } catch (e) {
            console.log(e);
            valid[44] = false;
          }
        }
      } else if (lastModified === 50) {
        let newErrors50 = { ...newErrors[50] };
        let attributes50 = getAttributeValues(newFormValues, 50);
        valid[50] = [];
        for (let index = 0; index < attributes50.length; index++) {
          let ocr = attributes50[index];
          if (
            !ocr.value ||
            ocr.value.length < 2 ||
            !getAttributeValue(ocr, 135)
          ) {
            valid[50][index] = false;
          } else if (ocr.value && !ocr.mandatory_match) {
            valid[50][index] = true;
            newErrors50 = update(newErrors50, {
              [index]: { $set: null },
            });
          } else if (ocr.mandatory_match) {
            try {
              let ocrExists = await fetchPost("profiles/search/ocr", {
                ocr: [
                  {
                    ocr: ocr.value,
                    type: getAttributeValue(ocr, 135),
                  },
                ],
                profile_type: profileType,
              });
              if (
                ocrExists.count === 0 ||
                (profile &&
                  profile.id &&
                  ocrExists.profiles.filter((p) => p.id !== profile.id)
                    .length === 0)
              ) {
                valid[50][index] = true;
                newErrors50 = update(newErrors50, {
                  [index]: { $set: null },
                });
              } else {
                valid[50][index] = false;
                newErrors50 = update(newErrors50, {
                  [index]: { $set: I18n.get("profiles_ocrAlreadyExists") },
                });
              }

              // Check bulk override if not update
              if (!profile || !profile.id) {
                checkBulkOverride(newFormValues, OCR, newExistingRecords);
              }
            } catch (e) {
              console.log(e);
              valid[50][index] = false;
            }
          }
        }
        newErrors[50] = newErrors50;
      }
      valid.ocrOrLpr =
        ((valid[50] &&
          valid[50].filter((item) => item === false).length === 0) ||
          getAttributeValues(newFormValues, 50).length === 0) &&
        (valid[44] ||
          (!getAttributeValue(newFormValues, 44) &&
            getAttributeValues(newFormValues, 50).filter(
              (v) => v.mandatory_match
            ).length > 0));
      valid.form =
        valid[18] &&
        valid[profileType === 2 ? 42 : 53] &&
        valid.tag &&
        valid[89] &&
        valid.ocrOrLpr;
    } else {
      if(lastModified === "sys_tag_id") {
        valid["tag"] = true
      } else if(lastModified === 291) {
        const containerID = getAttributeValue(newFormValues, lastModified)
        const ISOCompilationValue = getAttributeValue(newFormValues, 301)
        const containerIdValidation = get(profileValidationRules, ["containerIdValidation"]);
        
        valid[lastModified] = containerID?.length>0? isValidContainerID(containerID,containerIdValidation,ISOCompilationValue):true
        newErrors[lastModified] = !valid[lastModified] ? ISOCompilationValue? I18n.get("Invalid_containerID_ISO6346"):I18n.get("Invalid_custom_Container_ID"): ''

        const ocrCreateOrUpdate = get(containerIdValidation,["ocr"]);
        let isOcrValid=(profile && profile.id) ? ocrCreateOrUpdate.update:ocrCreateOrUpdate.create
        if(valid[lastModified] && containerID?.length==11 && isOcrValid){
            ocrValueUpdate(containerID,newFormValues)            
          }
        else if(valid[lastModified] || containerID?.length!==11 && isOcrValid){
          ocrValueUpdate(containerID,newFormValues,true) 
        }
      } else if(lastModified === 292){
        const containerSATC = getAttributeValue(newFormValues, lastModified)
        const satcValidation = get(profileValidationRules, ["satcValidation"]);
        valid[lastModified] = containerSATC?.length>0 && satcValidation.strict ? ContainerService.isValidSATC(containerSATC):true;
        newErrors[lastModified] = !valid[lastModified] ? I18n.get("Invalid_container_size_and_type"):'';
      } else {
        let attr = get(
          filter(profileAttributes, (attr) => attr.id === lastModified),
          [0]
        );
      
        if (attr && attr.active && attr.required) {
          valid[lastModified] = !includes(
            ["", undefined],
            getAttributeValue(newFormValues, lastModified)
          );
        }
      }
      valid.form =
        size(
          filter(
            profileAttributes,
            (attr) => attr.active && attr.required && !valid[attr.id]
          )
        ) === 0 && valid["tag"] ;
    }
    
    return [valid, newErrors];
  };

  const createProfile = async (enroll = false) => {
    try {
      
      let newProfile;
      const newAttributes = formValues.attributes.map((item) => {
        if(item.id === 39) { 
          return item = {
            ...item,
            value: item.value.trim()
          }
        }
        return item;
      }).filter((filterItem) => {
        if(filterItem.value) return filterItem
      });
      const requestPayload = {
        ...formValues,
        attributes: [...newAttributes]
      }
      if (profile && profile.id) {
        setLoading(I18n.get("site_updatingProfile"));
        newProfile = await fetchPut(`profiles/${profile.id}`, requestPayload);
        console.log("profile updated");
      } else {
        setLoading(I18n.get("site_creatingProfile"));
        newProfile = await fetchPost("profiles", requestPayload);
        console.log("profile created");

        // Save photos
        if (size(photos) > 0 || size(localPhotos) > 0) {
          for (let i = 0; i < size(photos); i++) {
            let imgName = photos[i];
            if (imgName && imgName.includes("/api/images/")) {
              let index = imgName.indexOf("/api/images/");
              imgName = imgName.substring(index + 12);
            }
            let img = await fetchGet(`images/${imgName}`);
            let body = {
              name: imgName,
              enrollment_status: false,
              enrollment_error: false,
              main_display: false,
              "image-base64": img,
            };
            await fetchPost(`profiles/${newProfile.id}/images`, body);
            console.log("image added to profile");
          }
          // Local photos
          for (let i = 0; i < size(localPhotos); i++) {
            let body = {
              name: uuidv4(),
              enrollment_status: false,
              enrollment_error: false,
              main_display: false,
              "image-base64": localPhotos[i],
            };
            await fetchPost(`profiles/${newProfile.id}/images`, body);
            console.log("image added to profile");
          }

          if (profileType === 1 && enroll) {
            await fetchPost(`profiles/${newProfile.id}/index`, {}, API_LUKE);
            console.log("profile indexed");
          }
        }
      }
      setCreatedProfile(newProfile);
      if (isMounted.current) setCreatedProfile(newProfile);

      if (
        bulkOverrideEnabled &&
        existingRecords &&
        existingRecords.total &&
        existingRecords.total.records &&
        existingRecords.total.records.length > 0
      ) {
        let body = {
          event_groups: [...existingRecords.total.records],
          profile: {
            id: newProfile.id,
          },
        };
        let res = await fetchPut("override/event_groups", body);
        console.log("bulkoverride", res);
      }
      if (isMounted.current) {
        setLoading(false);
        setWarningProcess(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleDeleteProfile = async () => {
    try {
      if (profile && profile.id) {
        //let res = await fetchDelete(`profiles/${profile.id}`);
        //console.log(res);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const renderDeleteWarning = () => {
    return (
      <Dialog open={true}>
        <Grid container direction="column" style={{ padding: "30px" }}>
          <Grid item className="text-center text-54">
            {I18n.get("profiles_deleteWarning")}
          </Grid>
          <Grid
            item
            className="text-center text-87"
            style={{ marginTop: "25px" }}
          >
            <img src={images.warningIcon} alt="warning" width="50px" />
          </Grid>
          <Grid item style={{ marginTop: "25px" }}>
            <Grid container justify="center">
              <Grid item>
                <CustomButton
                  color="primary"
                  style={{ marginRight: "10px" }}
                  onClick={() => setDeleteProcess(false)}
                >
                  {I18n.get("site_no")}
                </CustomButton>
              </Grid>
              <Grid item>
                <CustomButton
                  color="primary"
                  variant="contained"
                  style={{ marginLeft: "10px" }}
                  onClick={handleDeleteProfile}
                >
                  {I18n.get("site_yes")}
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    );
  };

  const renderAssignmentWarning = () => {
    return (
      <Dialog open={true}>
        <Grid container direction="column" style={{ padding: "36px" }}>
          <Grid
            item
            className="text-center text-87"
            style={{ marginBottom: "25px" }}
          >
            <img src={images.warningIcon} alt="warning" width="50px" />
          </Grid>
          <Grid item className="text-center text-54">
            {!get(formValues, ["company_id"])
              ? I18n.get("profiles_assignmentWarningCompany")
              : !get(formValues, ["site_id"])
              ? I18n.get("profiles_assignmentWarningSite")
              : ""}
          </Grid>
          <Grid item style={{ marginTop: "25px" }}>
            <Grid container justify="center">
              <Grid item>
                <CustomButton
                  color="primary"
                  style={{ marginRight: "10px" }}
                  onClick={() => setWarningProcess(false)}
                >
                  {I18n.get("site_no")}
                </CustomButton>
              </Grid>
              <Grid item>
                <CustomButton
                  color="primary"
                  variant="contained"
                  style={{ marginLeft: "10px" }}
                  onClick={createProfile}
                >
                  {I18n.get("site_yes")}
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    );
  };

  if (loading || !lov.tag) {
    return (
      <Box
        style={{
          width: profile ? "100%" : "400px",
          height: profile ? "100%" : "250px",
        }}
      >
        <Loader
          height={profile ? "100%" : "250px"}
          message={typeof loading === "string" ? loading : null}
        />
      </Box>
    );
  }

  if (props.express) {
    return (
      <HumanFormExpress
        section="main"
        data={formValues}
        lov={lov}
        handleChange={handleChange}
        validForm={validForm}
        errors={errors}
        language={language}
        close={props.close}
        createProfile={createProfile}
        localPhotos={localPhotos}
        setLocalPhotos={setLocalPhotos}
        profileValidationRules={profileValidationRules}
        flow={flow}
      />
    );
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{
        height: "100%",
        minHeight: "600px",
        minWidth: "800px",
        padding: "24px",
        width: "calc(100vw - 80px)",
        maxWidth: "100%",
      }}
      wrap="nowrap"
    >
      <Grid item zeroMinWidth style={{ padding: "0px 12px 24px" }}>
        {deleteProcess && renderDeleteWarning()}
        {warningProcess && renderAssignmentWarning()}
        <Grid container>
          <Grid item xs={2} className={classes.titleBarItem + " bold-500"}>
            {I18n.get("profiles_active")}
            <Checkbox
              color="primary"
              checked={formValues.active}
              onChange={(e) => handleChange("active", 0, e.target.checked)}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid
            item
            xs={4}
            className={classes.titleBarItem + " text-87"}
            style={{
              justifyContent: "center",
              fontSize: "1.15em",
            }}
          >
            {(!profile || !profile.id) && (
              <>
                {includes([1, 2, 3, 4, 5, 6, 8], profileType) && (
                  <img
                    height="20px"
                    style={{
                      marginRight: "10px",
                      marginTop: "-4px",
                      maxWidth: "40px",
                    }}
                    src={getProfileTypeIcon(profileType)}
                    alt="profile icon"
                  />
                )}
                {get(
                  filter(
                    get(lov, ["profileTypes"]),
                    (pt) => pt.id === profileType
                  ),
                  [0, `name_${language}`]
                )}
              </>
            )}
          </Grid>
          <Grid
            item
            xs={4}
            style={{ justifyContent: "flex-end" }}
            className={classes.titleBarItem}
          >
            {/* {profile && profile.id && (
              <CustomButton
                color="secondary"
                onClick={() => setDeleteProcess(true)}
                style={{ marginRight: "auto" }}
              >
                {I18n.get("profiles_deleteProfile")}
              </CustomButton>
            )} */}
            {props.close && (
              <CustomButton color="primary" onClick={props.close}>
                {I18n.get("site_cancel")}
              </CustomButton>
            )}
            <CustomButton
              variant="contained"
              color="primary"
              disabled={!validForm.form}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                (!get(formValues, ["company_id"]) ||
                  !get(formValues, ["site_id"])) &&
                profileType === 1
                  ? setWarningProcess(true)
                  : createProfile();
              }}
            >
              {profile && profile.id
                ? I18n.get("account_update")
                : I18n.get("site_create")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
      {!disablePhotos && (
        <Grid item zeroMinWidth style={{ marginBottom: "20px" }}>
          <DetailsContainer
            title={
              [2, 3].includes(profileType)
                ? I18n.get("site_contextPhotos")
                : I18n.get("site_photos")
            }
          >
            {photos && photos.length > 0 ? (
              <Grid container>
                {photos.map((photo, index) => (
                  <Grid item key={index}>
                    <Grid container direction="column">
                      <Grid
                        item
                        style={{
                          width: "72px",
                          height: "72px",
                          marginLeft: 0,
                          marginRight: "20px",
                          border: "1px solid " + colors.veryLighPink,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Picture
                          key={index}
                          url={photo}
                          alt={"context_photo"}
                          maxHeight={70}
                          style={{
                            maxWidth: "70px",
                            maxHeight: "70px",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        style={{
                          textAlign: "right",
                          paddingRight: "20px",
                          paddingTop: "10px",
                        }}
                      >
                        <img
                          src={images.deleteIcon}
                          alt="delete"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setPhotos(update(photos, { $splice: [[index, 1]] }))
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box
                className="text-54"
                style={{ fontStyle: "italic", fontSize: "0.875em" }}
              >
                {I18n.get("site_noPhoto")}
              </Box>
            )}
          </DetailsContainer>
        </Grid>
      )}
      <Grid item zeroMinWidth style={{ marginBottom: "20px" }}>
        <DetailsContainer title={I18n.get("site_mainDetails")}>
          {profileType === 1 ? (
            <HumanForm
              section="main"
              data={formValues}
              lov={lov}
              handleChange={handleChange}
              validForm={validForm}
              errors={errors}
              permission={!permission}
              language={language}
              profileAttributes={filter(
                profileAttributes,
                (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
              )}
              profileValidationRules={profileValidationRules}
            />
          ) : [2, 3].includes(profileType) ? (
            <VehicleForm
              profileType={profileType}
              section="main"
              data={formValues}
              lov={lov}
              handleChange={handleChange}
              validForm={validForm}
              setValidForm={setValidForm}
              errors={errors}
              language={language}
              permission={!permission}
              existingRecords={existingRecords}
              bulkOverrideEnabled={bulkOverrideEnabled}
              setBulkOverrideEnabled={setBulkOverrideEnabled}
              profileAttributes={filter(
                profileAttributes,
                (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
              )}
            />
          ) : [8].includes(profileType) ? (
            <RailCarForm
              profileType={profileType}
              profileAttributes={profileAttributes}
              section="main"
              data={formValues}
              lov={lov}
              handleChange={handleChange}
              validForm={validForm}
              errors={errors}
              language={language}
            />
          ) : (
              <ContainerForm
                profileType={profileType}
                profileAttributes={profileAttributes}
                section="main"
                data={formValues}
                lov={lov}
                handleChange={handleChange}
                validForm={validForm}
                errors={errors}
                language={language}
                profileValidationRules={profileValidationRules}

              />
          )}
          {profileType === 1 ?<Grid
            container
            style={{
              marginTop: "20px",
              maxWidth: "770px",
              backgroundColor: colors.lightGrey,
              paddingTop: "10px",
            }}
          >
            <Grid
              item
              className="flexCenter"
              style={{
                justifyContent: "center",
                width: "50px",
                marginBottom: "10px",
              }}
            >
              <img src={images.userLoginIcon} alt="user_login" />
            </Grid>
            <Grid item style={{ width: "220px" }}>
              <Grid container direction="column">
                <InfoSection
                  title="username"
                  values={[get(profile, ["user", "username"])]}
                />
              </Grid>
            </Grid>
            <Grid item style={{ width: "220px" }}>
              <Grid container direction="column">
                <InfoSection
                  title2={getAttributeName(33)}
                  values={[getAttributeValue(profile, 33)]}
                />
              </Grid>
            </Grid>
          </Grid>:null}
          <Grid
            container
            style={{
              marginTop: "20px",
              maxWidth: "770px",
              backgroundColor: colors.lightGrey,
            }}
          >
            <Grid
              item
              className="flexCenter"
              style={{
                justifyContent: "center",
                width: "50px",
              }}
            >
              <img src={images.companyIcon} alt="company" />
            </Grid>
            <Grid
              item
              style={{
                maxWidth: "220px",
                width: "220px",
                padding: "10px 8px 0px",
              }}
            >
              <FormSection
                formValue={[get(formValues, ["company_id"])]}
                setFormValue={handleChange}
                title="assignedCompany"
                id={"company_id"}
                type="select"
                options={{
                  disabled: !isAllowed(
                    get(user, ["permissions"]),
                    "access.cross.companies.admin"
                  ),
                  comboBox: true,
                  options: map(get(lov, ["companies"]), (c) => ({
                    id: get(c, ["id"]),
                    name: get(c, ["name"]),
                  })),
                }}
              />
            </Grid>
            <Grid
              item
              style={{
                maxWidth: "220px",
                width: "220px",
                padding: "10px 8px 0px",
              }}
            >
              <FormSection
                formValue={[get(formValues, ["site_id"])]}
                setFormValue={handleChange}
                title="assignedSite"
                id={"site_id"}
                type="select"
                options={{
                  disabled: !isAllowed(
                    get(user, ["permissions"]),
                    "access.cross.sites.admin"
                  ),
                  comboBox: true,
                  options: map(
                    get(
                      filter(
                        get(lov, ["companies"]),
                        (c) => c.id === get(formValues, ["company_id"])
                      ),
                      [0, "sites"]
                    ),
                    (t) => ({
                      id: t.id,
                      name: t.name,
                    })
                  ),
                }}
              />
            </Grid>
            <Grid
              item
              style={{
                maxWidth: "220px",
                width: "220px",
                padding: "10px 8px 0px",
              }}
            >
              <FormSection
                formValue={[get(formValues, ["zone_id"])]}
                setFormValue={handleChange}
                title="assignedZone"
                id={"zone_id"}
                type="select"
                options={{
                  comboBox: true,
                  options: map(
                    get(
                      filter(
                        get(
                          filter(
                            get(lov, ["companies"]),
                            (c) => c.id === get(formValues, ["company_id"])
                          ),
                          [0, "sites"]
                        ),
                        (s) => s.id === get(formValues, ["site_id"])
                      ),
                      [0, "zones"]
                    ),
                    (t) => ({
                      id: t.id,
                      name: t.name,
                    })
                  ),
                }}
              />
            </Grid>
          </Grid>
          <ProfileLocation
            itemSizes={{
              xs: 6,
              sm: 3,
              md: 3,
              xl: 3,
            }}
            profileType={profileType}
            profile={profile}
            user={user}
            refresh={null}
            editDisabled={true}
          />
        </DetailsContainer>
      </Grid>
      <Grid item zeroMinWidth>
        {size(
          filter(
            profileAttributes,
            (attr) =>
              get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
          )
        ) > 0 && (
          <DetailsContainer title={I18n.get("site_secondaryDetails")}>
            {profileType === 1 ? (
              <HumanForm
                section="secondary"
                data={formValues}
                lov={lov}
                handleChange={handleChange}
                validForm={validForm}
                errors={errors}
                language={language}
                permission={!permission}
                profileAttributes={filter(
                  profileAttributes,
                  (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
                )}
              />
            ) : [2, 3].includes(profileType) ? (
              <VehicleForm
                profileType={profileType}
                section="secondary"
                data={formValues}
                lov={lov}
                handleChange={handleChange}
                validForm={validForm}
                errors={errors}
                permission={!permission}
                language={language}
                profileAttributes={filter(
                  profileAttributes,
                  (attr) => !includes(get(excludeAttr, [profileType]), attr.id)
                )}
              />
            ) : (
              <GenericForm
                profileType={profileType}
                profileAttributes={profileAttributes}
                section="secondary"
                data={formValues}
                lov={lov}
                handleChange={handleChange}
                validForm={validForm}
                errors={errors}
                language={language}
              />
            )}
          </DetailsContainer>
        )}
      </Grid>
    </Grid>
  );
};

ProfileForm.propTypes = {
  profileType: PropTypes.number.isRequired,
  profile: PropTypes.object,
  setCreatedProfile: PropTypes.func,
  photos: PropTypes.array,
  disablePhotos: PropTypes.bool,
  detectionId: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileForm));
